module.exports = "<div>\r\n    <ul>\r\n        <li ng-repeat=\"(slug, genre) in genres\"><a href=\"/bp/{{ slug }}\" ng-click=\"click(slug, genre)\">{{ genre.title }}</a></li>\r\n    </ul>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/html/genres_nav.html
 ** module id = 54
 ** module chunks = 0
 **/